// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as signedOutRouteRouteImport } from './routes/(signed-out)/route'
import { Route as privateshellRouteRouteImport } from './routes/(private)/(shell)/route'
import { Route as HealthIndexRouteImport } from './routes/health/index'
import { Route as STokenRouteRouteImport } from './routes/s/$token/route'
import { Route as privateshellIndexRouteImport } from './routes/(private)/(shell)/index'
import { Route as privateshellAdminRouteRouteImport } from './routes/(private)/(shell)/admin/route'
import { Route as privateshellGroupsRouteRouteImport } from './routes/(private)/(shell)/groups/route'
import { Route as signedOutLoginIndexRouteImport } from './routes/(signed-out)/login/index'
import { Route as InviteCodeIndexRouteImport } from './routes/invite/$code/index'
import { Route as STokenIndexRouteImport } from './routes/s/$token/index'
import { Route as privateshellAdminIndexRouteImport } from './routes/(private)/(shell)/admin/index'
import { Route as privateshellFavoritesIndexRouteImport } from './routes/(private)/(shell)/favorites/index'
import { Route as privateshellFilesIndexRouteImport } from './routes/(private)/(shell)/files/index'
import { Route as privateshellGroupsIndexRouteImport } from './routes/(private)/(shell)/groups/index'
import { Route as privateshellLinksIndexRouteImport } from './routes/(private)/(shell)/links/index'
import { Route as privateshellSearchIndexRouteImport } from './routes/(private)/(shell)/search/index'
import { Route as privateshellSettingsProfileRouteRouteImport } from './routes/(private)/(shell)/settings/profile/route'
import { Route as privateshellSharedIndexRouteImport } from './routes/(private)/(shell)/shared/index'
import { Route as privateshellTrashIndexRouteImport } from './routes/(private)/(shell)/trash/index'
import { Route as privateViewNodeIdIndexRouteImport } from './routes/(private)/view/$nodeId/index'
import { Route as AppAuthCallbackIndexRouteImport } from './routes/app/auth/callback/index'
import { Route as privateshellAdminAuditIndexRouteImport } from './routes/(private)/(shell)/admin/audit/index'
import { Route as privateshellAdminLinksIndexRouteImport } from './routes/(private)/(shell)/admin/links/index'
import { Route as privateshellAdminPeopleIndexRouteImport } from './routes/(private)/(shell)/admin/people/index'
import { Route as privateshellAdminPoliciesIndexRouteImport } from './routes/(private)/(shell)/admin/policies/index'
import { Route as privateshellAdminSessionsIndexRouteImport } from './routes/(private)/(shell)/admin/sessions/index'
import { Route as privateshellFilesNodeIdIndexRouteImport } from './routes/(private)/(shell)/files/$nodeId/index'
import { Route as privateshellGroupsGroupIdIndexRouteImport } from './routes/(private)/(shell)/groups/$groupId/index'
import { Route as privateshellSettingsProfileIndexRouteImport } from './routes/(private)/(shell)/settings/profile/index'
import { Route as privateshellSharedNodeIdIndexRouteImport } from './routes/(private)/(shell)/shared/$nodeId/index'
import { Route as signedOutOSlugLoginIndexRouteImport } from './routes/(signed-out)/o/$slug/login/index'
import { Route as STokenFNodeIdIndexRouteImport } from './routes/s/$token/f/$nodeId/index'

const privateRouteRoute = privateRouteRouteImport.update({
            id: '/(private)',getParentRoute: () => rootRouteImport
          })
const signedOutRouteRoute = signedOutRouteRouteImport.update({
            id: '/(signed-out)',getParentRoute: () => rootRouteImport
          })
const privateshellRouteRoute = privateshellRouteRouteImport.update({
            id: '/(shell)',getParentRoute: () => privateRouteRoute
          })
const HealthIndexRoute = HealthIndexRouteImport.update({
            id: '/health/',path: '/health/',getParentRoute: () => rootRouteImport
          })
const STokenRouteRoute = STokenRouteRouteImport.update({
            id: '/s/$token',path: '/s/$token',getParentRoute: () => rootRouteImport
          })
const privateshellIndexRoute = privateshellIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateshellRouteRoute
          })
const privateshellAdminRouteRoute = privateshellAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => privateshellRouteRoute
          })
const privateshellGroupsRouteRoute = privateshellGroupsRouteRouteImport.update({
            id: '/groups',path: '/groups',getParentRoute: () => privateshellRouteRoute
          })
const signedOutLoginIndexRoute = signedOutLoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => signedOutRouteRoute
          })
const InviteCodeIndexRoute = InviteCodeIndexRouteImport.update({
            id: '/invite/$code/',path: '/invite/$code/',getParentRoute: () => rootRouteImport
          })
const STokenIndexRoute = STokenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => STokenRouteRoute
          })
const privateshellAdminIndexRoute = privateshellAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateshellAdminRouteRoute
          })
const privateshellFavoritesIndexRoute = privateshellFavoritesIndexRouteImport.update({
            id: '/favorites/',path: '/favorites/',getParentRoute: () => privateshellRouteRoute
          })
const privateshellFilesIndexRoute = privateshellFilesIndexRouteImport.update({
            id: '/files/',path: '/files/',getParentRoute: () => privateshellRouteRoute
          })
const privateshellGroupsIndexRoute = privateshellGroupsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateshellGroupsRouteRoute
          })
const privateshellLinksIndexRoute = privateshellLinksIndexRouteImport.update({
            id: '/links/',path: '/links/',getParentRoute: () => privateshellRouteRoute
          })
const privateshellSearchIndexRoute = privateshellSearchIndexRouteImport.update({
            id: '/search/',path: '/search/',getParentRoute: () => privateshellRouteRoute
          })
const privateshellSettingsProfileRouteRoute = privateshellSettingsProfileRouteRouteImport.update({
            id: '/settings/profile',path: '/settings/profile',getParentRoute: () => privateshellRouteRoute
          })
const privateshellSharedIndexRoute = privateshellSharedIndexRouteImport.update({
            id: '/shared/',path: '/shared/',getParentRoute: () => privateshellRouteRoute
          })
const privateshellTrashIndexRoute = privateshellTrashIndexRouteImport.update({
            id: '/trash/',path: '/trash/',getParentRoute: () => privateshellRouteRoute
          })
const privateViewNodeIdIndexRoute = privateViewNodeIdIndexRouteImport.update({
            id: '/view/$nodeId/',path: '/view/$nodeId/',getParentRoute: () => privateRouteRoute
          })
const AppAuthCallbackIndexRoute = AppAuthCallbackIndexRouteImport.update({
            id: '/app/auth/callback/',path: '/app/auth/callback/',getParentRoute: () => rootRouteImport
          })
const privateshellAdminAuditIndexRoute = privateshellAdminAuditIndexRouteImport.update({
            id: '/audit/',path: '/audit/',getParentRoute: () => privateshellAdminRouteRoute
          })
const privateshellAdminLinksIndexRoute = privateshellAdminLinksIndexRouteImport.update({
            id: '/links/',path: '/links/',getParentRoute: () => privateshellAdminRouteRoute
          })
const privateshellAdminPeopleIndexRoute = privateshellAdminPeopleIndexRouteImport.update({
            id: '/people/',path: '/people/',getParentRoute: () => privateshellAdminRouteRoute
          })
const privateshellAdminPoliciesIndexRoute = privateshellAdminPoliciesIndexRouteImport.update({
            id: '/policies/',path: '/policies/',getParentRoute: () => privateshellAdminRouteRoute
          })
const privateshellAdminSessionsIndexRoute = privateshellAdminSessionsIndexRouteImport.update({
            id: '/sessions/',path: '/sessions/',getParentRoute: () => privateshellAdminRouteRoute
          })
const privateshellFilesNodeIdIndexRoute = privateshellFilesNodeIdIndexRouteImport.update({
            id: '/files/$nodeId/',path: '/files/$nodeId/',getParentRoute: () => privateshellRouteRoute
          })
const privateshellGroupsGroupIdIndexRoute = privateshellGroupsGroupIdIndexRouteImport.update({
            id: '/$groupId/',path: '/$groupId/',getParentRoute: () => privateshellGroupsRouteRoute
          })
const privateshellSettingsProfileIndexRoute = privateshellSettingsProfileIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateshellSettingsProfileRouteRoute
          })
const privateshellSharedNodeIdIndexRoute = privateshellSharedNodeIdIndexRouteImport.update({
            id: '/shared/$nodeId/',path: '/shared/$nodeId/',getParentRoute: () => privateshellRouteRoute
          })
const signedOutOSlugLoginIndexRoute = signedOutOSlugLoginIndexRouteImport.update({
            id: '/o/$slug/login/',path: '/o/$slug/login/',getParentRoute: () => signedOutRouteRoute
          })
const STokenFNodeIdIndexRoute = STokenFNodeIdIndexRouteImport.update({
            id: '/f/$nodeId/',path: '/f/$nodeId/',getParentRoute: () => STokenRouteRoute
          })





const privateshellAdminRouteRouteChildren = {
  privateshellAdminIndexRoute: privateshellAdminIndexRoute,privateshellAdminAuditIndexRoute: privateshellAdminAuditIndexRoute,privateshellAdminLinksIndexRoute: privateshellAdminLinksIndexRoute,privateshellAdminPeopleIndexRoute: privateshellAdminPeopleIndexRoute,privateshellAdminPoliciesIndexRoute: privateshellAdminPoliciesIndexRoute,privateshellAdminSessionsIndexRoute: privateshellAdminSessionsIndexRoute
}

const privateshellAdminRouteRouteWithChildren = privateshellAdminRouteRoute._addFileChildren(privateshellAdminRouteRouteChildren)




const privateshellGroupsRouteRouteChildren = {
  privateshellGroupsIndexRoute: privateshellGroupsIndexRoute,privateshellGroupsGroupIdIndexRoute: privateshellGroupsGroupIdIndexRoute
}

const privateshellGroupsRouteRouteWithChildren = privateshellGroupsRouteRoute._addFileChildren(privateshellGroupsRouteRouteChildren)




const privateshellSettingsProfileRouteRouteChildren = {
  privateshellSettingsProfileIndexRoute: privateshellSettingsProfileIndexRoute
}

const privateshellSettingsProfileRouteRouteWithChildren = privateshellSettingsProfileRouteRoute._addFileChildren(privateshellSettingsProfileRouteRouteChildren)



const privateshellRouteRouteChildren = {
  privateshellAdminRouteRoute: privateshellAdminRouteRouteWithChildren,privateshellGroupsRouteRoute: privateshellGroupsRouteRouteWithChildren,privateshellIndexRoute: privateshellIndexRoute,privateshellSettingsProfileRouteRoute: privateshellSettingsProfileRouteRouteWithChildren,privateshellFavoritesIndexRoute: privateshellFavoritesIndexRoute,privateshellFilesIndexRoute: privateshellFilesIndexRoute,privateshellLinksIndexRoute: privateshellLinksIndexRoute,privateshellSearchIndexRoute: privateshellSearchIndexRoute,privateshellSharedIndexRoute: privateshellSharedIndexRoute,privateshellTrashIndexRoute: privateshellTrashIndexRoute,privateshellFilesNodeIdIndexRoute: privateshellFilesNodeIdIndexRoute,privateshellSharedNodeIdIndexRoute: privateshellSharedNodeIdIndexRoute
}

const privateshellRouteRouteWithChildren = privateshellRouteRoute._addFileChildren(privateshellRouteRouteChildren)



const privateRouteRouteChildren = {
  privateshellRouteRoute: privateshellRouteRouteWithChildren,privateViewNodeIdIndexRoute: privateViewNodeIdIndexRoute
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(privateRouteRouteChildren)




const signedOutRouteRouteChildren = {
  signedOutLoginIndexRoute: signedOutLoginIndexRoute,signedOutOSlugLoginIndexRoute: signedOutOSlugLoginIndexRoute
}

const signedOutRouteRouteWithChildren = signedOutRouteRoute._addFileChildren(signedOutRouteRouteChildren)




const STokenRouteRouteChildren = {
  STokenIndexRoute: STokenIndexRoute,STokenFNodeIdIndexRoute: STokenFNodeIdIndexRoute
}

const STokenRouteRouteWithChildren = STokenRouteRoute._addFileChildren(STokenRouteRouteChildren)

const rootRouteChildren = {
  privateRouteRoute: privateRouteRouteWithChildren,signedOutRouteRoute: signedOutRouteRouteWithChildren,STokenRouteRoute: STokenRouteRouteWithChildren,HealthIndexRoute: HealthIndexRoute,InviteCodeIndexRoute: InviteCodeIndexRoute,AppAuthCallbackIndexRoute: AppAuthCallbackIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)